import { IconButton, Popover, SvgIcon } from '@mui/material';
import * as React from 'react';
import { AutoMockupContainer } from './AutomockupContainer';

export const StarSetAnimatedIcon = () => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <style>
        {`
              #eJVBvKOycDj2_ts {animation: eJVBvKOycDj2_ts__ts 2000ms linear infinite normal forwards}
              #eJVBvKOycDj3_ts {animation: eJVBvKOycDj3_ts__ts 2000ms linear infinite normal forwards}
              #eJVBvKOycDj4_ts {animation: eJVBvKOycDj4_ts__ts 2000ms linear infinite normal forwards}
              @keyframes eJVBvKOycDj2_ts__ts { 0% {transform: translate(11px,12.75px) scale(1,1)} 25% {transform: translate(11px,12.75px) scale(1.25,1.25)} 50% {transform: translate(11px,12.75px) scale(1,1)} 100% {transform: translate(11px,12.75px) scale(1,1)}}
              @keyframes eJVBvKOycDj3_ts__ts { 0% {transform: translate(18px,18.25px) scale(1,1)} 50% {transform: translate(18px,18.25px) scale(1,1)} 75% {transform: translate(18px,18.25px) scale(1.313317,1.313317)} 100% {transform: translate(18px,18.25px) scale(1,1)}}
              @keyframes eJVBvKOycDj4_ts__ts { 0% {transform: translate(17px,5.75px) scale(1,1)} 25% {transform: translate(17px,5.75px) scale(1,1)} 50% {transform: translate(17px,5.75px) scale(1.400859,1.400859)} 75% {transform: translate(17px,5.75px) scale(1.033333,1.033333)} 100% {transform: translate(17px,5.75px) scale(1.033333,1.033333)}}
            `}
      </style>
      <g id="eJVBvKOycDj2_ts" transform="translate(11,12.75) scale(1,1)">
        <path
          d="M10.5,7.5L8,2L5.5,7.5L0,10l5.5,2.5L8,18l2.5-5.5L16,10L10.5,7.5ZM8.99,10.99L8,13.17l-.99-2.18L4.83,10l2.18-.99L8,6.83l.99,2.18l2.18.99-2.18.99Z"
          transform="translate(-8,-10)"
          fill="#00598b"
        />
      </g>
      <g id="eJVBvKOycDj3_ts" transform="translate(18,18.25) scale(1,1)">
        <path
          d="M14.9375,2.0625L14,0l-.9375,2.0625L11,3l2.0625.9375L14,6l.9375-2.0625L17,3l-2.0625-.9375Zm-.5663,1.30875L14,4.18875l-.3712-.8175L12.8112,3l.8176-.37125L14,1.81125l.3712.8175L15.1888,3l-.8176.37125Z"
          transform="translate(-14,-3)"
          fill="#00598b"
        />
      </g>
      <g id="eJVBvKOycDj4_ts" transform="translate(17,5.75) scale(1,1)">
        <path
          d="M14.9375,2.0625L14,0l-.9375,2.0625L11,3l2.0625.9375L14,6l.9375-2.0625L17,3l-2.0625-.9375Zm-.5663,1.30875L14,4.18875l-.3712-.8175L12.8112,3l.8176-.37125L14,1.81125l.3712.8175L15.1888,3l-.8176.37125Z"
          transform="translate(-14,-3)"
          fill="#00598b"
        />
      </g>
    </SvgIcon>
  );
};

export const StarSetIcon = () => (
  <SvgIcon>
    <path
      d="M10.5 8.5L8 3L5.5 8.5L0 11L5.5 13.5L8 19L10.5 13.5L16 11L10.5 8.5ZM8.99 11.99L8 14.17L7.01 11.99L4.83 11L7.01 10.01L8 7.83L8.99 10.01L11.17 11L8.99 11.99Z"
      fill="#009DC8"
    />
    <path d="M18 14L16.75 16.75L14 18L16.75 19.25L18 22L19.25 19.25L22 18L19.25 16.75L18 14Z" fill="#009DC8" />
    <path d="M18 8L19.25 5.25L22 4L19.25 2.75L18 0L16.75 2.75L14 4L16.75 5.25L18 8Z" fill="#009DC8" />
  </SvgIcon>
);

export default function AutoMockupButton({
  children,
  handleAutomockupOpen,
  anchorEl,
}: {
  children: React.ReactNode;
  handleAutomockupOpen: (element: HTMLElement | null) => void;
  anchorEl: HTMLElement | null;
}) {
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        aria-label="automockup button"
        id="automockup-popover-button"
        onClick={({ currentTarget }) => handleAutomockupOpen(currentTarget)}
      >
        <StarSetAnimatedIcon />
      </IconButton>
      <Popover
        id="automockup-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleAutomockupOpen(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ zIndex: 1300, maxWidth: 460 }}
      >
        <AutoMockupContainer handleAutomockupOpen={handleAutomockupOpen} />
      </Popover>
    </>
  );
}
